<div [ngSwitch]="showStatus">
  <div *ngSwitchCase="'IRstatus'">
    <table style="width:100%" id="tbljournalmastr" class="table table-striped table-hover">
      <thead class="table-light absolute ">
        <tr>
          <th scope="col">#</th>
          <th scope="col" style="display:none">JournalID</th>
          <th scope="col">Journal</th>
          <th scope="col">Inprocess</th>
          <th scope="col">Response</th>
          <th scope="col" hidden>Approved</th>
          <th scope="col">All</th>
          <th scope="col" *ngIf="showColumn">Actions</th>
        </tr>
      </thead>
      <tbody id="table-scroll">
        <tr *ngFor="let item of ajournalCt; index as i">
          <td class="td-align">{{i+1}}</td>
          <td style="display:none">{{ ajournalCt[i].JournalId }}</td>
          <td>{{ ajournalCt[i].Acronym }}</td>
          <td class="td-align"><span class='link' (click)="addNewItem(ajournalCt[i].JournalId  , 'Inprocess' )">{{ ajournalCt[i].Inprocess }}</span></td>
          <td class="td-align"><span class='link' (click)="addNewItem(ajournalCt[i].JournalId , 'Response' )">{{ ajournalCt[i].Response }}</span></td>
          <td class="td-align" hidden><span class='link' (click)="addNewItem(ajournalCt[i].JournalId , 'Approve' )">{{ ajournalCt[i].Approve }}</span></td>
          <td class="td-align"><span class='link' (click)="addNewItem(ajournalCt[i].JournalId , 'AllIR' )">{{ ajournalCt[i].Total }}</span></td>
          <td class="td-align" *ngIf="showColumn">
            <span id="btn_add" class='link' (click)="addNewItem(ajournalCt[i].JournalId , 'Journal' )"><i class="fa fa-plus-square  blue-color" data-toggle="tooltip" data-placement="top" title="Create Defect"></i></span>
          </td>
        </tr>
      </tbody>
    </table>
    <div id="LoadingImage">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
    </div>
  </div>
  <div *ngSwitchCase="'ARstatus'">
    <div>
      <table style="width:100%" id="tbljournalmastrAR" class="table table-striped table-hover">
        <thead class="table-light absolute">
          <tr>
            <th scope="col">#</th>
            <th scope="col" style="display:none">JournalID</th>
            <th scope="col">Journal</th>
            <th scope="col">Approve</th>
            <th scope="col">Reject</th>
            <th scope="col">All</th>
          </tr>
        </thead>
        <tbody id="table-scroll">
          <tr *ngFor="let item of ajournalCt; index as i">
            <td class="td-align">{{i+1}}</td>
            <td style="display:none">{{ ajournalCt[i].JournalId }}</td>
            <td>{{ ajournalCt[i].Acronym }}</td>
            <td class="td-align"><span class='link' (click)="addNewItem(ajournalCt[i].JournalId  , 'Approve' )">{{ ajournalCt[i].Approve }}</span></td>
            <td class="td-align"><span class='link' (click)="addNewItem(ajournalCt[i].JournalId  , 'Reject' )">{{ ajournalCt[i].Reject }}</span></td>
            <td class="td-align"><span class='link' (click)="addNewItem(ajournalCt[i].JournalId , 'AllAR' )">{{ ajournalCt[i].Total }}</span></td>
          </tr>
        </tbody>
      </table>
      <div id="LoadingImage">
        <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'Due'">
    <table style="width:100%" id="tbljournalmastr" class="table table-striped table-hover">
      <thead class="table-light absolute">
        <tr>
          <th scope="col">#</th>
          <th scope="col" style="display:none">JournalID</th>
          <th scope="col">Journal</th>
          <th scope="col">OverDue</th>
          <th scope="col">OnDue</th>
          <th scope="col">DueFor</th>
          <th scope="col">All</th>
        </tr>
      </thead>
      <tbody id="table-scroll">
        <tr *ngFor="let item of ajournalCt; index as i">
          <td class="td-align">{{i+1}}</td>
          <td style="display:none">{{ ajournalCt[i].JournalId }}</td>
          <td>{{ ajournalCt[i].Acronym }}</td>
          <td class="td-align"><span class='link' (click)="addNewItem(ajournalCt[i].JournalId  , 'OverDue' )">{{ ajournalCt[i].OverDue }}</span></td>
          <td class="td-align"><span class='link' (click)="addNewItem(ajournalCt[i].JournalId , 'OnDue' )">{{ ajournalCt[i].OnDue }}</span></td>
          <td class="td-align"><span class='link' (click)="addNewItem(ajournalCt[i].JournalId , 'DueFor' )">{{ ajournalCt[i].DueFor }}</span></td>
          <td class="td-align"><span class='link' (click)="addNewItem(ajournalCt[i].JournalId , 'AllIR' )">{{ ajournalCt[i].Total }}</span></td>
        </tr>
      </tbody>
    </table>
    <div id="LoadingImage">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
    </div>
  </div>
  <div *ngSwitchDefault> </div>
</div>





